export const variantPrefix = 'premioempreendedoracuritibana2023'

export const origins = {
  projectOriginIdentifier: `${variantPrefix}project`,
  step2OriginIdentifier: `${variantPrefix}step2`,
}

export const originsIdentifiers = Object.values(origins)
